import React, { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminLayout from '@/components/admin/AdminLayout'

const PageFallback = () => (
  <div className="min-h-[40vh] flex items-center justify-center text-slate-600">
    Loading…
  </div>
)

const HomePage = lazy(() => import('@/pages/HomePage'))
const LessonsPage = lazy(() => import('@/pages/LessonsPage'))
const DashboardPage = lazy(() => import('@/pages/DashboardPage'))
const EvaluationPage = lazy(() => import('@/pages/EvaluationPage'))
const RecordingsPage = lazy(() => import('@/pages/RecordingsPage'))
const ProfilePage = lazy(() => import('@/pages/ProfilePage'))
const PresentationPage = lazy(() => import('@/pages/PresentationPage'))
const DevelopersPage = lazy(() => import('@/pages/DevelopersPage'))
const ContactPage = lazy(() => import('@/pages/ContactPage'))
const SignupPage = lazy(() => import('@/pages/SignupPage'))
const TermsOfServicePage = lazy(() => import('@/pages/TermsOfServicePage'))
const PrivacyPolicyPage = lazy(() => import('@/pages/PrivacyPolicyPage'))
const StudentDashboardPage = lazy(() => import('@/pages/StudentDashboardPage'))
const StudentProfilePage = lazy(() => import('@/pages/StudentProfilePage'))
const StudentLessonsPage = lazy(() => import('@/pages/StudentLessonsPage'))
const StudentPlatformLessonsPage = lazy(() => import('@/pages/StudentPlatformLessonsPage'))
const StudentDashboardRedirect = lazy(() => import('@/pages/StudentDashboardRedirect'))
const AdminDashboardPage = lazy(() => import('@/pages/admin/AdminDashboardPage'))
const AdminStudentsPage = lazy(() => import('@/pages/admin/AdminStudentsPage'))
const AdminPunishPage = lazy(() => import('@/pages/admin/AdminPunishPage'))
const AdminSpeakingTestPage = lazy(() => import('@/pages/admin/AdminSpeakingTestPage'))
const AdminRobotDetectPage = lazy(() => import('@/pages/admin/AdminRobotDetectPage'))
const AdminCheckTtsPage = lazy(() => import('@/pages/admin/AdminCheckTtsPage'))
const AdminTranscriptsPage = lazy(() => import('@/pages/admin/AdminTranscriptsPage'))
const AdminStudentsTestLessonPage = lazy(() => import('@/pages/admin/AdminStudentsTestLessonPage'))
const AdminReadingDetectorTestPage = lazy(() => import('@/pages/admin/AdminReadingDetectorTestPage'))
const AdminImproveTranscriptTestPage = lazy(() => import('@/pages/admin/AdminImproveTranscriptTestPage'))
const AdminContentPage = lazy(() => import('@/pages/admin/AdminContentPage'))
const AdminLessonEditorPage = lazy(() => import('@/pages/admin/AdminLessonEditorPage'))
const AdminLessonTestPage = lazy(() => import('@/pages/admin/AdminLessonTestPage'))
const AdminLessonCreatorPage = lazy(() => import('@/pages/admin/AdminLessonCreatorPage'))
const AdminVocabularyEditorPage = lazy(() => import('@/pages/admin/AdminVocabularyEditorPage'))
const AdminEvaluationCreatorPage = lazy(() => import('@/pages/admin/AdminEvaluationCreatorPage'))
const AdminEvaluationEditorPage = lazy(() => import('@/pages/admin/AdminEvaluationEditorPage'))

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/lessons" element={<LessonsPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/evaluation" element={<EvaluationPage />} />
        <Route path="/recordings" element={<RecordingsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/presentation" element={<PresentationPage />} />
        <Route path="/developers" element={<DevelopersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/auth/signup" element={<SignupPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/student_dashboard" element={<StudentDashboardPage />} />
        <Route path="/student/dashboard" element={<StudentDashboardRedirect />} />
        <Route path="/student/profile" element={<StudentProfilePage />} />
        <Route path="/student/lessons" element={<StudentLessonsPage />} />
        <Route path="/student/platform-lessons" element={<StudentPlatformLessonsPage />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboardPage />} />
          <Route path="students" element={<AdminStudentsPage />} />
          <Route path="students/test-lesson" element={<AdminStudentsTestLessonPage />} />
          <Route path="punish" element={<AdminPunishPage />} />
          <Route path="logs" element={<AdminSpeakingTestPage />} />
          <Route path="speaking-test" element={<Navigate to="/admin/logs" replace />} />
          <Route path="robot-detect" element={<AdminRobotDetectPage />} />
          <Route path="robot-detect/check-tts" element={<AdminCheckTtsPage />} />
          <Route path="transcripts" element={<AdminTranscriptsPage />} />
          <Route path="reading-detector-test" element={<AdminReadingDetectorTestPage />} />
          <Route path="improve-transcript-test" element={<AdminImproveTranscriptTestPage />} />
          <Route path="content" element={<AdminContentPage />} />
          <Route path="content/lessons/new" element={<AdminLessonCreatorPage />} />
          <Route path="content/lessons/:id" element={<AdminLessonEditorPage />} />
          <Route path="content/lessons/:id/test" element={<AdminLessonTestPage />} />
          <Route path="content/vocabulary/:id" element={<AdminVocabularyEditorPage />} />
          <Route path="content/evaluation/new" element={<AdminEvaluationCreatorPage />} />
          <Route path="content/evaluation/:id" element={<AdminEvaluationEditorPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
